import * as types from '../../reduxStore/types/orders';

export const appendOrderFromNotification = (orderDetails) => {
    return {
        type: types.APPEND_NEW_ORDER_FROM_NOTIFICATION,
        payload: orderDetails,
    };
};
